import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import {
  useCreateOrder,
  useCustomerShippingType,
  useDistricts,
  useListBus,
  useListCustomerByKeySearch,
  useLocationsByCustomer,
  useProvinces,
  useTimeSlots,
  useWards,
} from "hooks";
import { getInitCustomerParams } from "pages/CustomerManagement/utils";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import MessageModal from "../../../components/shared-components/MessageModal";
import OrderForm from "../OrdersForm/OrdersForm";

const initBusParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-maker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
  };
};

const initLocationParams = () => {
  return {
    shipping_type: "2,3",
    keywords: "",
  };
};

const initCustomerShippingTypeParams = () => {
  return {
    customerId: "",
  };
};

const initLocalitiesParams = () => {
  return {
    countryId: 1,
    type: 1,
    parent_code: "",
  };
};

const DistrictOrderPage = props => {
  const { t } = useTranslation(["order"]);
  const navigate = useNavigate();

  const [provinceParams, setProvinceParams] = useState(initLocalitiesParams);
  const [districtParams, setDistrictParams] = useState(initLocalitiesParams);
  const [wardParams, setWardParams] = useState(initLocalitiesParams);
  const [shipping, setShipping] = useState();
  const [customerParams, setCustomerParams] = useState(getInitCustomerParams);
  const [locationParams, setLocationParams] = useState(initLocationParams);
  const [openPopup, setOpenPopup] = useState(false);
  const [orderCode, setOrderCode] = useState("");
  const [customerCode, setCustomerCode] = useState("");
  const [messagePopups, setMessagePopups] = useState([]);
  const [customerShippingTypeParams, setCustomerShippingTypeParams] = useState(
    initCustomerShippingTypeParams
  );
  const { data: customers, refetch: listCustomer } = useListCustomerByKeySearch(
    {
      params: customerParams,
    }
  );

  useEffect(() => {
    if (customerParams && customerParams.run) {
      listCustomer();
    }
  }, [customerParams, listCustomer]);

  useEffect(() => {
    setCustomerParams(prev => ({
      ...prev,
      sizePerPage: 100,
      run: true,
      shipping_type: "2,3",
      columnFilter: {
        "filter[record_status]": "O",
      },
    }));
  }, []);

  const [busParams, setBusParams] = useState(initBusParams);

  const { data: timeSlot } = useTimeSlots({ params: { type: 2 } });
  const { data: buses, refetch: fetchBusList } = useListBus({
    params: busParams,
  });

  useEffect(() => {
    if (busParams && busParams.run) {
      fetchBusList();
    }
  }, [busParams, fetchBusList]);

  const { data: provinces, refetch: refetchProvinces } =
    useProvinces(provinceParams);
  const { data: districts, refetch: refetchDistricts } =
    useDistricts(districtParams);
  const { data: wards, refetch: refetchWards } = useWards(wardParams);
  const { data: districtAll, refetch: getDistricts } = useDistricts({
    countryId: 1,
    type: 2,
    parent_code: "",
  });
  const { data: wardAll, refetch: getWards } = useWards({
    countryId: 1,
    type: 3,
    parent_code: "",
  });

  const { data: locationsCustomer, refetch: refetchLocationCustomer } =
    useLocationsByCustomer({
      customerId: locationParams?.customerId,
      params: locationParams,
    });

  const { data: customerShippingType, refetch: refetchCustomerShippingType } =
    useCustomerShippingType(customerShippingTypeParams);

  const handleChangeCustomer = customerId => {
    setCustomerShippingTypeParams(prev => ({
      ...prev,
      customerId: customerId,
    }));
    setLocationParams(prev => ({
      ...prev,
      customerId: customerId,
    }));
  };

  const onSuccessCreateOrder = _data => {
    if (_data.shipping_type === 3 || customerCode === "GSNEW") {
      setOrderCode(_data.order_code);
      const mes = [];
      if (_data.shipping_type === 3) {
        mes.push({
          value: t("message.note", {
            order_code: _data.order_code,
          }),
          class: "",
        });
      }
      if (customerCode === "GSNEW") {
        mes.push({
          value: t("message.note_create_GSNEW"),
          class: "text-danger",
        });
      }
      setMessagePopups(mes);
      setOpenPopup(true);
    } else if (_data.shipping_type === 2) {
      const mes = [];
      mes.push({
        value: t("message.note_shipping_type"),
        class: "",
      });
      setMessagePopups(mes);
      setOpenPopup(true);
    } else {
      navigate("/manage-orders");
    }
  };

  const onErrorCreateOrder = _data => {};

  const { mutate: createOrder, isLoading: isCreateOrder } = useCreateOrder(
    onSuccessCreateOrder,
    onErrorCreateOrder
  );
  const handleCreateOrder = data => {
    setOrderCode("");
    setCustomerCode(data.customer_code);
    createOrder(data);
  };

  const handleShippingTypeChange = value => {
    if (value === 3) {
      setBusParams(prev => ({
        ...prev,
        run: true,
        sizePerPage: 100,
        columnFilter: {
          "filter[record_status]": "O",
        },
      }));
    }
  };

  const onSearchBusChange = ({ keywords, actions }) => {
    if (actions.action == "input-change") {
      if (keywords) {
        setBusParams(prev => ({
          ...prev,
          sizePerPage: 100,
          columnFilter: {
            "filter[record_status]": "O",
            "filter[name][like]": keywords.trim().replaceAll(" ", "+"),
          },
        }));
      } else {
        setBusParams(prev => ({
          ...prev,
          sizePerPage: 100,
          columnFilter: { "filter[record_status]": "O" },
        }));
      }
    }
  };

  useEffect(() => {
    if (buses) {
      const { items } = buses;
      setShipping(items);
    }
  }, [buses]);

  useEffect(() => {
    const { customerId } = locationParams;
    if (customerId) {
      refetchLocationCustomer();
    }
  }, [locationParams, refetchLocationCustomer]);

  useEffect(() => {
    const { customerId } = customerShippingTypeParams;
    if (customerId) {
      console.log("🚀 ~ useEffect ~ refetchCustomerShippingType:");
      refetchCustomerShippingType();
    }
  }, [customerShippingTypeParams, refetchCustomerShippingType]);

  useEffect(() => {
    refetchProvinces();
    getDistricts();
    getWards();
  }, []);

  useEffect(() => {
    if (provinceParams?.type === 1) refetchProvinces();
  }, [provinceParams, refetchProvinces]);

  useEffect(() => {
    if (districtParams?.type === 2) refetchDistricts();
  }, [districtParams, refetchDistricts]);

  useEffect(() => {
    if (wardParams?.type === 3) refetchWards();
  }, [wardParams, refetchWards]);

  const toggleModalNotify = () => {
    setOpenPopup(!openPopup);
    handleCancel();
  };

  const handleCancel = () => {
    navigate("/manage-orders");
  };
  const handleLocationKeywordsChange = value => {
    setLocationParams(prev => ({ ...prev, keywords: value }));
  };
  const handleCustomerKeywordsChange = value => {
    setCustomerParams(prev => ({ ...prev, keywords: value }));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MessageModal
          isOpen={openPopup}
          autoFocus={true}
          centered={true}
          toggle={toggleModalNotify}
          clickOutsideNotClose={true}
          type={"infor"}
          // message={t('message.note', {
          //   order_code: orderCode
          // })}
          messages={messagePopups}
        ></MessageModal>
        <MetaTags>
          <title>
            {t("title.create", {
              location: t("location.district"),
            })}
          </title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.create", {
              location: t("location.district"),
            })}
            breadcrumbItems={[
              { name: t("title.manager") },
              { name: t("title.list"), link: "/manage-orders" },
              { name: t("title.create") },
            ]}
          />
        </div>
        <Container fluid={true}>
          <OrderForm
            customers={customers?.items}
            timeSlots={timeSlot?.items}
            buses={shipping}
            locationsCustomer={locationsCustomer?.items}
            handleChangeCustomer={handleChangeCustomer}
            provinces={provinces}
            districts={districts}
            wards={wards}
            districtAll={districtAll}
            wardAll={wardAll}
            createOrder={handleCreateOrder}
            onChangeProvince={value => {
              setDistrictParams(prev => ({
                ...prev,
                type: 2,
                parent_code: value,
              }));
            }}
            onChangeDistrict={value => {
              setWardParams(prev => ({ ...prev, type: 3, parent_code: value }));
            }}
            onKeywordsChange={handleCustomerKeywordsChange}
            onChangeShippingType={handleShippingTypeChange}
            refetchLocationCustomer={refetchLocationCustomer}
            handleCancel={handleCancel}
            onLocationKeywordsChange={handleLocationKeywordsChange}
            customerShippingType={customerShippingType}
            onSearchBusChange={onSearchBusChange}
            isCreateOrder={isCreateOrder}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DistrictOrderPage;
